import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const ReinviteIcon = forwardRef<SVGSVGElement, IconProps>(function ReinviteIcon(
  { color = '', height = 13, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.78181 5.61372C7.64055 5.48696 7.38992 5.38873 6.96021 5.39029L6.95875 5.39029H4.98915C4.92255 5.39029 4.85691 5.39328 4.79598 5.39901L4.78871 5.39969C4.43537 5.42651 4.23301 5.52792 4.11685 5.64985C4.00241 5.76998 3.91708 5.96728 3.91708 6.30197V7.40084C3.91708 7.90418 4.03064 8.07524 4.12935 8.15237C4.25613 8.25142 4.49567 8.31253 4.98524 8.31253H6.947C7.34891 8.31253 7.59675 8.22877 7.74385 8.11684C7.87908 8.01394 7.97821 7.85002 8.00523 7.56559L8.00619 7.55653C8.01205 7.5068 8.01517 7.45264 8.01517 7.39734V6.29848C8.01517 5.9365 7.91519 5.7334 7.78181 5.61372ZM8.32163 5.01211C8.67674 5.33076 8.82345 5.78556 8.82345 6.29848V7.39734C8.82345 7.48047 8.81891 7.5647 8.80947 7.64652C8.76525 8.10207 8.58444 8.49289 8.23331 8.76008C7.89291 9.0191 7.44571 9.12082 6.947 9.12082H4.98524C4.49198 9.12082 3.99537 9.07344 3.6317 8.78929C3.23997 8.48321 3.10879 7.99636 3.10879 7.40084V6.30197C3.10879 5.83176 3.23099 5.40789 3.53162 5.09233C3.82976 4.77937 4.24864 4.63059 4.72393 4.59393C4.81066 4.5859 4.90037 4.582 4.98915 4.582H6.95804C7.4952 4.58017 7.97457 4.7007 8.32163 5.01211Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.22117 6.9269L3.33021 5.96838L3.69566 5.24742L5.58662 6.20595C5.82517 6.32687 6.10708 6.32687 6.34563 6.20595L8.23659 5.24742L8.60204 5.96838L6.71108 6.9269C6.24281 7.16427 5.68944 7.16427 5.22117 6.9269Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1845 6.75811C11.2343 5.4691 11.0289 4.17158 10.484 3.34293C9.74999 2.22676 8.98634 1.8695 8.5496 1.72657C8.33747 1.65714 8.22179 1.42889 8.29121 1.21676C8.36064 1.00463 8.58889 0.888946 8.80102 0.958372C9.38794 1.15046 10.3119 1.6101 11.1593 2.89883C11.8411 3.93552 12.0445 5.4359 11.9921 6.78935C11.94 8.13839 11.628 9.46958 11.1593 10.1823C10.7998 10.729 10.3222 11.3636 9.49957 11.8531C8.67738 12.3423 7.54822 12.6649 5.91534 12.6649C5.69214 12.6649 5.5112 12.4839 5.5112 12.2607C5.5112 12.0375 5.69214 11.8566 5.91534 11.8566C7.44077 11.8566 8.41818 11.556 9.08627 11.1585C9.7539 10.7612 10.1503 10.2457 10.484 9.73818C10.8331 9.20735 11.1344 8.05153 11.1845 6.75811Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.12526 1.25561C8.12526 1.03241 8.3062 0.851465 8.5294 0.851465H10.9826C11.2058 0.851465 11.3867 1.03241 11.3867 1.25561C11.3867 1.47881 11.2058 1.65975 10.9826 1.65975H8.93355V3.74264C8.93355 3.96585 8.7526 4.14679 8.5294 4.14679C8.3062 4.14679 8.12526 3.96585 8.12526 3.74264V1.25561Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.815498 6.75821C0.765632 8.04722 0.971058 9.34474 1.51597 10.1734C2.3228 11.4003 3.1673 11.7128 3.5803 11.8292C3.79513 11.8898 3.92017 12.1131 3.8596 12.3279C3.79902 12.5427 3.57576 12.6678 3.36094 12.6072C2.80403 12.4501 1.77669 12.041 0.840619 10.6175C0.158895 9.5808 -0.0445452 8.08042 0.00781419 6.72697C0.0600027 5.37793 0.371952 4.04674 0.840618 3.33404C1.20011 2.78735 1.67774 2.15268 2.50039 1.66321C3.32258 1.17401 4.45173 0.85144 6.08462 0.85144C6.30782 0.85144 6.48876 1.03238 6.48876 1.25558C6.48876 1.47879 6.30782 1.65973 6.08462 1.65973C4.55918 1.65973 3.58178 1.96033 2.91369 2.35784C2.24606 2.75508 1.84969 3.27066 1.51597 3.77814C1.1669 4.30897 0.865536 5.46479 0.815498 6.75821Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.87458 12.4473C3.87458 12.6705 3.69364 12.8514 3.47043 12.8514H1.01725C0.794045 12.8514 0.613103 12.6705 0.613103 12.4473C0.613103 12.2241 0.794045 12.0432 1.01725 12.0432H3.06629L3.06629 9.96026C3.06629 9.73706 3.24723 9.55612 3.47043 9.55612C3.69364 9.55612 3.87458 9.73706 3.87458 9.96026L3.87458 12.4473Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
